<template functional>
    <div class="lotto-results__row--terminal">
        <div class="lotto-results__timestamp--terminal">
            <span>{{ $options.filters.formatDateTime(props.date, 'ddmm') }}</span>
            <span>•</span>
            <span>{{ $options.filters.formatDateTime(props.date, 'time') }}</span>
        </div>
        <div class="lotto-results__game-title--terminal">
            <div class="lotto-results__draw-name--terminal">
                {{ props.name }}
            </div>
            <div class="lotto-results__draw-type--terminal">
                <span class="lotto-results__draw-type-circle--terminal circle--outline">
                    {{ props.numbersDrawn }}
                </span>
                <span class="lotto-results__draw-type-circle--terminal circle--fill">
                    {{ props.totalNumbers }}
                </span>
            </div>
        </div>
        <div class="lotto-results__numbers-drawn--terminal">
            <span
                v-for="result in props.results"
                :key="result"
                class="lotto-results__draw-result-ball--terminal"
            >
                {{ result }}
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'LottoGridRow',
        functional: true,
        inheritAttrs: false,
        props: {
            name: {
                type: String,
                required: true
            },
            date: {
                type: Date,
                required: true,
            },
            results: {
                type: Array,
                required: true,
            },
            numbersDrawn: {
                type: Number,
                required: true,
            },
            totalNumbers: {
                type: Number,
                required: true,
            },
        },
        filters: {
            formatDateTime: (date, format) => Vue.filter('formatDateTime')(date, format),
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/results/lottoOffer/content/LottoGridRow.vue